/**
 * Pure validation helpers for form input.
 *
 * Kept free of React so the rules can be unit-tested in isolation and reused
 * by the full intake form when it replaces the landing-page stub.
 */

// Pragmatic email shape check: non-empty local part, single @, dotted domain.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns true if the value is a plausibly-valid email address.
 * Trims surrounding whitespace before checking.
 */
export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}
